import { useCustomNavigate } from 'core/hooks/useCustomNavigate';
import React, { useEffect } from "react";
import ArrowLeft from "../../assets/icons/header/arrow_left.svg";
import CartBadge from "./CartBadge";

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  showCart?: boolean;
  handleGoBack?: () => void;
  className?: string;
  sticky?: boolean;
  rightAction?: React.ReactNode;
  iconLeft?: any;
  isShowBorder?: boolean;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  showCart = true,
  handleGoBack,
  className,
  sticky,
  rightAction,
  iconLeft,
  isShowBorder = true
}) => {
  const navigate = useCustomNavigate()
  
  const _handleGoBack = () => {
    if (handleGoBack) {
      handleGoBack()
    } else {
      navigate(-1)
    }
  }

  useEffect(() => {
    
    if ((window as any).webViewCallGetListPath) {
      (window as any).webViewCallGetListPath([(window as any).location?.pathname])
    }
    (window as any).backFromDeviceAndroid = function() {
      if (handleGoBack) {
        handleGoBack()
      } else {
        navigate(-1)
      }
    }

    return () => {
      (window as any).backFromDeviceAndroid = undefined
    }
  }, [navigate,handleGoBack])

  return (
    <div
      className={`
        shadows
        fixed w-full z-10 top-0
        ${className || 'bg-white'}
        ${sticky ? 'sticky top-0 z-50' : ''}
      `}
    >
      <nav className="flex justify-between items-center px-[16px] pb-[12px] pt-[10px] max-h-[43px]">
        <button className="w-[24px] h-[24px]" onClick={_handleGoBack}>
          <img src={iconLeft || ArrowLeft} alt="back" />
        </button>
        <h1 className="text-[15px] font-title font-bold flex-1 text-left pl-[14px] leading-none">
          {title}
        </h1>
        {showCart && <>
          <CartBadge className='px-0'/>
          {/* <Bell /> */}
        </> }
        {rightAction}
      </nav>
     {isShowBorder ? <div className="h-[1px] bg-[#eeeeee]"></div> : '' }
    </div>
  );
};

export default PageHeader;
